import "./Competitionnews.css";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import series from "../../competitionImage/series.jpg";
import timer from "./timer.png";
import arrow from "./Arrow - Left 2.png";
import message from "./messages-2.png";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import Skeleton from "../../../../components/Skeleton";
import worldCup from "../../../home/HomeImage/worldcup.png";
import { Helmet } from "react-helmet-async";

const Competitionnews = ({ dark, news = [], loading = false, competition }) => {
  const createSlug = (leagueName) => {
    return leagueName
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const leagueData = competition?.league || {};

  const leagueId = leagueData?.id;

  const slug = createSlug(leagueData?.name);

  const country =
    competition?.country?.name || competition?.country || "Unknown Country";

  const currentSeason = competition?.season?.year || competition?.season || "";

  const leagueName = leagueData?.name || "Competition";
  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        setIsStickyTop(window.scrollY >= 98);
      } else {
        setIsStickyTop(window.scrollY >= 300);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="homer">
      <Helmet>
        ({" "}
        <title>
          {`{leagueName || leagueData?.name} News | {country} Football Season {currentSeason}`}
        </title>
        )
        <meta
          name="description"
          content={`Latest news, updates, transfers, and stories from ${leagueName || leagueData?.name} in ${country} Football Season ${currentSeason}. Stay updated with match previews, breaking news, and analysis.`}
        />
        <meta
          name="keywords"
          content={`${leagueName}, ${country} football news, latest transfers, match updates, football headlines, season ${currentSeason}`}
        />
        <meta
          property="og:title"
          content={`${leagueName || leagueData?.name} News`}
        />
        <meta
          property="og:description"
          content={`Get the latest news, updates, and stories from ${leagueName || leagueData?.name} - ${country} Football Season ${currentSeason}.`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${leagueName || leagueData?.name} News`}
        />
        <meta
          name="twitter:description"
          content={`Latest football news and updates from ${leagueName || leagueData?.name}.`}
        />
        {leagueData?.logo && (
          <meta name="twitter:image" content={leagueData.logo} />
        )}
      </Helmet>

      <div className="compnewsWrapper">
        {!loading && news.length > 0 ? (
          <h1
            id="h1"
            style={dark ? { color: "#f7f7f7ff" } : { color: "#161819" }}>
            {leagueName} News
          </h1>
        ) : (
          <></>
        )}
        {loading && (
          <p
            style={
              dark
                ? { color: "#d4d4d4ff", marginTop: "20px" }
                : { marginTop: "20px", color: "#3E3F3F" }
            }>
            <Skeleton dark={dark} count={6} />
          </p>
        )}
        {news.length > 0 && (
          <section className="thirdsectioned">
            {news.slice(0, 1).map((item, index) => (
              <NavLink to={`/news/${item?.slug}`} className="new">
                <div
                  key={item?.id || index}
                  style={dark ? { backgroundColor: "#333333ff" } : {}}>
                  <img
                    src={item?.image !== null ? item?.image : series}
                    alt={item?.title}
                  />

                  <nav
                    className="deep con"
                    style={
                      dark
                        ? { backgroundColor: "#141414" }
                        : { backgroundColor: "#2e2e2e04" }
                    }>
                    <h2
                      style={
                        dark ? { color: "#fafafaff" } : { color: "#fafafaff" }
                      }>
                      {item?.title?.length > 70
                        ? item.title.slice(0, 70) + "..."
                        : item?.title}
                    </h2>
                  </nav>
                </div>
              </NavLink>
            ))}
          </section>
        )}

        {news.length > 1 && (
          <section className="fourthsection">
            {news.slice(1, 10).map((item, index) => (
              <NavLink to={`/news/${item?.slug}`} className="new">
                <div
                  key={item?.id || index}
                  style={
                    dark
                      ? { backgroundColor: "#333333ff" }
                      : { backgroundColor: "white" }
                  }>
                  <nav>
                    <img
                      src={item?.image !== null ? item?.image : series}
                      alt={item?.title}
                    />
                  </nav>

                  <nav className="con">
                    <h2 style={dark ? {} : { color: "#161819" }}>
                      {item?.title?.length > 70
                        ? item.title.slice(0, 70) + "..."
                        : item?.title}
                    </h2>

                    {/* <div>
                    <span>
                          <img src={timer} alt="" />
                          <strong>55hrs</strong>
                      </span>

                      <span>  
                          <img src={message} alt="" />
                          <strong>240</strong>
                      </span>
                  </div> */}
                  </nav>
                </div>
              </NavLink>
            ))}
          </section>
        )}
      </div>
    </div>
  );
};

export default Competitionnews;
